import React from 'react';
import { styled } from 'styled-components';
import { MessageContainer } from './MessageContainer';
import { Colors } from '../../../../play-core/styles/Colors';
import { Fonts } from '../../../../play-core/styles/Fonts';
import { jsx as _jsx } from "react/jsx-runtime";
export const Message = ({
  text,
  type = 'Info',
  className
}) => /*#__PURE__*/_jsx(MessageContainer, {
  type: type,
  className: className,
  children: /*#__PURE__*/_jsx(MessageText, {
    children: text
  })
});
export const MessageText = styled.span.withConfig({
  displayName: "Message__MessageText",
  componentId: "sc-12uzwho-0"
})(["", ";line-height:26px;padding:11px 40px;color:", ";a{", ";color:", ";}"], Fonts.light(18), Colors.GREY_d2d2d2, Fonts.bold(18), Colors.WHITE);